<input #inputChart hidden="true" id="chart" type="file" accept="image/*" (change)="handleAddChart( $event )" capture="environment" /> <!-- add capture="environment" for image only (prompts for rear-facing camera) -->
<mat-toolbar color="accent">
  <mat-toolbar-row class="chart-toolbar-row">
    <span>Chart</span>
    <span class="spacer"></span>
    <!-- https://stackoverflow.com/questions/8581081/how-to-access-a-mobiles-camera-from-a-web-app -->
    <ng-container *ngIf="hasButtonUpload">
      <div class="chart-toolbar-secondary">
        <button mat-raised-button type="button" aria-label="Skip" (click)="handleSkipStep()" *ngIf="hasNewPatient">
          Skip
        </button>
        <button
          mat-raised-button
          type="button"
          class="chart-upload-button"
          aria-label="Edit"
          [disabled]="!isChartLoaded"
          (click)="inputChart.click()">
          <mat-icon>add_a_photo</mat-icon>
        </button>
        <button
          mat-raised-button
          type="button"
          class="chart-download-button"
          *ngIf="!hasNewPatient"
          aria-label="Download"
          [disabled]="!chartImage"
          (click)="handleButtonDownloadChart()">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-raised-button type="button" class="chart-delete-button" aria-label="Delete" color="warn" (click)="handleButtonDeleteChart()" *ngIf="chartImage">
          <mat-icon>delete_outline</mat-icon>
        </button>
        <button
          mat-raised-button
          type="button"
          color="white"
          class="chart-zoom-toggle-button"
          *ngIf="!hasNewPatient"
          [attr.aria-label]="areZoomControlsVisible ? 'Hide zoom controls' : 'Show zoom controls'"
          [disabled]="!chartImage"
          (click)="handleToggleZoomControls()">
          <mat-icon>{{ areZoomControlsVisible ? 'keyboard_double_arrow_up' : 'keyboard_double_arrow_down' }}</mat-icon>
        </button>
      </div>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>

<div class="chart-zoom-bar" *ngIf="hasButtonUpload && !hasNewPatient && areZoomControlsVisible">
  <div class="chart-toolbar-zoom">
    <input
      class="chart-zoom-input"
      type="text"
      aria-label="Current zoom percent"
      [value]="zoomPercent + '%'"
      disabled />
    <button
      mat-raised-button
      type="button"
      aria-label="Zoom Out"
      [disabled]="!chartImage || zoomPercent <= zoomMinPercent"
      (click)="handleZoomOut()">
      <mat-icon>remove</mat-icon>
    </button>
    <button
      mat-raised-button
      type="button"
      class="chart-zoom-reset-button"
      aria-label="Reset Zoom"
      [disabled]="!chartImage || zoomPercent === zoomDefaultPercent"
      (click)="handleZoomReset()">
      <mat-icon>refresh</mat-icon>
    </button>
    <button
      mat-raised-button
      type="button"
      aria-label="Zoom In"
      [disabled]="!chartImage"
      (click)="handleZoomIn()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>

<mat-card *ngIf="!chartImage && isChartLoaded" class="chart-placeholder-card" (click)="inputChart.click()">
    <mat-icon class="chart-placeholder-icon">
        camera_alt
    </mat-icon>
</mat-card>

<app-image-zoom
  *ngIf="chartImage"
  [imageSource]="chartImage"
  [zoomPercent]="zoomPercent"
  (fitZoomCalculated)="handleFitZoomCalculated($event)"
  (zoomPercentChange)="handleZoomPercentChange($event)">
</app-image-zoom>
